<div class="d-flex align-items-center" [class.locked]="!editable()">
    <div class="checkbox-container" [class.dimmed]="dimmed()">
        <input
            class="checkbox-field-input"
            type="checkbox"
            [id]="fieldId()"
            [checked]="checked()"
            [disabled]="!editable()"
            [required]="required()"
            [attr.aria-label]="label() ? undefined : ariaLabel()"
            [attr.aria-invalid]="isInvalid()"
            [class.is-valid]="isValid()"
            [class.is-invalid]="isInvalid()"
            (change)="onChange($event)"
            (blur)="touched.set(true)"
        />
        @if (checked()) {
            <fa-icon [icon]="faCheck" size="2x"></fa-icon>
        }
    </div>
    @if (label()) {
        <label class="ms-2 mb-0" [for]="fieldId()">{{ label() }}</label>
    }
</div>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
